module.exports = __webpack_public_path__ + "static/media/material_arrow_up_blue.72a309ac.svg";